import React from 'react';
import './it training.css';

function ItTraining() {
  return (
    <div className="it-training-container">
      <section className="team-details padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 sm-padding">
              <div className="team-details-thumb">
                <img src="assets/img/team-1.jpg" alt="thumb" />
                <div className="info-content">
                  <i className="fa-solid fa-chalkboard-teacher" />
                  <h3>100% <span>Online Learning Excellence</span></h3>
                </div>
              </div>
            </div>
            <div className="col-lg-6 sm-padding">
              <div className="section-heading mb-30">
                <h2>About iTrain – Empowering Future-Ready Tech Talent</h2>
                <p>
                  At Tita Technologies, we believe that learning is the foundation of innovation and success. iTrain is our dedicated training platform designed to bridge the skill gap and empower aspiring professionals with industry-relevant expertise.
                </p>
                <p>
                  Our training programs cover cutting-edge technologies, including React.js, Node.js, Java, Python, Data Science, Artificial Intelligence, Cybersecurity, and more. With a focus on hands-on experience, real-world applications, and project-based learning, we ensure that learners develop practical skills that meet industry demands.
                </p>
                <h3>Why Choose iTrain?</h3>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li>Expert-Led Training – Learn from industry professionals with real-world experience.</li>
                  <li>Structured Learning Paths – Step-by-step modules designed for beginners to advanced learners.</li>
                  <li>Interactive LMS – Access training anytime, anywhere through our Learning Management System (LMS).</li>
                  <li>Industry Certifications – Earn globally recognized certifications that enhance career opportunities.</li>
                  <li>Corporate & Individual Training – Tailored programs for students, working professionals, and enterprises.</li>
                  <li>Strong Industry Partnerships – Collaborations with top tech firms to ensure up-to-date curriculum and job-ready skills.</li>
                </ul>
                <p>
                  With iTrain by Tita Technologies, individuals and organizations can upskill, reskill, and stay ahead in the ever-evolving technology landscape. Whether you're a student looking to start your career, a professional seeking growth, or a company aiming to train employees, iTrain is your gateway to success.
                </p>
                <p>
                  Join us today and transform your future with the power of learning!
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ItTraining;